module.exports = __webpack_public_path__ + "static/2-a9c93597eb4212ac6eaec800134488c3.png";